import { handleActions } from 'redux-actions';
import { HIDE_DIALOG, RESET_DIALOG, SET_DIALOG_DATA, SHOW_DIALOG } from './actions';

const showDialog = (prevState, { payload: { dialogName, data } }) => ({
  ...prevState,
  [dialogName]: {
    ...prevState[dialogName],
    show: true,
    data: {
      ...(prevState[dialogName] ? prevState[dialogName].data : {}),
      ...data,
    },
  },
});

const hideDialog = (prevState, { payload: { dialogName } }) => ({
  ...prevState,
  [dialogName]: {
    ...prevState[dialogName],
    show: false,
  },
});

const setDialogData = (prevState, { payload: { dialogName, data } }) => ({
  ...prevState,
  [dialogName]: {
    ...prevState[dialogName],
    data: data,
  },
});

const resetDialogData = (prevState, { payload: { dialogName } }) => ({
  [dialogName]: {
    show: false,
    data: null,
  },
});

export const reducer = handleActions(
  {
    [SHOW_DIALOG]: showDialog,
    [HIDE_DIALOG]: hideDialog,
    [SET_DIALOG_DATA]: setDialogData,
    [RESET_DIALOG]: resetDialogData,
  },
  {}
);
